/*
This is just a rectangle that can be drawn for debug purposes.
It sets up a flat object for Base.drawOutline to work with
*/
import Base from './Base';

export default class Rect extends Base {
  constructor(args) {
    super(args);
    this.item = { ...args.item, z: 0, depth: 1 };
    this.ratio = args.ratio;
    this.x = this.item.x;
    this.y = this.item.y;

    this.calculateProjection();
  }
}
